module.exports = __webpack_public_path__ + "img/rewards.4ca14b68.svg";